search = '';
let appendedContentSearch = '';  
var cntrlIsPressed = false;

targetNode = document
config = { attributes: true, childList: true, subtree: true };
observer = new MutationObserver(
    function () {
        document.querySelectorAll('.search input[id="search"]').forEach(
            function (element) { 
                if (typeof element.value != undefined && element.value != '') {
                    search = element.value
                } 
            }
        )
    }
);

observer.observe(targetNode, config);

if (sessionStorage['urls']) {
    var urls = JSON.parse(sessionStorage['urls'] || '[]')

    for (let i = 0; i < urls.length; i++ ) {
        const url = urls[i];

        if (url.path == window.location.href) {
            countPage = url.page;
        }
    }
}

function detec() { 
  if (navigator.userAgent.match(/Android/i) 
      || navigator.userAgent.match(/webOS/i) 
      || navigator.userAgent.match(/iPhone/i)  
      || navigator.userAgent.match(/iPad/i)  
      || navigator.userAgent.match(/iPod/i) 
      || navigator.userAgent.match(/BlackBerry/i) 
      || navigator.userAgent.match(/Windows Phone/i)) { 
      return true; 
  } else {
    return false;
  }
} 

$(document).keydown(function(event) {
  switch(event.which) {
    case 17:
      cntrlIsPressed = true;
    case 91:
      cntrlIsPressed = true; 
    case 93:
      cntrlIsPressed = true;
    case 224:
      cntrlIsPressed = true;         
  }

  switch(event.button) {
    case 17:
        cntrlIsPressed = true;
      case 91:
        cntrlIsPressed = true; 
      case 93:
        cntrlIsPressed = true;
      case 224:
        cntrlIsPressed = true;         
  }

});

$(document).keyup(function(){
  cntrlIsPressed = false;
});

function getOS() {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  if (os == 'Mac OS') {
    return true
  } else {
    return false;
  }

}

$(document).on('click', '.product-list.search-matrix .thumbnail .product-wrap', function() {

  var scrolled_Y = window.scrollY;
  var scrolled_X = window.scrollX;
  var scrolled = [scrolled_X, scrolled_Y];

  var leftButton = detec();
  var oS = getOS();

  if (leftButton) {
    saveScrollSearch(countPage, scrolled, appendedContentSearch);
  } 

  if (oS) {
    if (!event.metaKey) {
      switch (event.which) {
        case 1:
          saveScrollSearch(countPage, scrolled, appendedContentSearch);
          break;
        default:
          console.log("mac os df which");
      }
      switch(event.button) {
        case 0:
          saveScrollSearch(countPage, scrolled, appendedContentSearch);
          break;
        default:
          console.log(" mac osdf button");   
      }
    }
  } else {
    if (!cntrlIsPressed) {
      switch (event.which) {
        case 1:
          saveScrollSearch(countPage, scrolled, appendedContentSearch);
          break;
        default:
          console.log("df which");
      }
      switch(event.button) {
        case 0:
          saveScrollSearch(countPage, scrolled, appendedContentSearch);
          break;
        default:
          console.log("df button");   
      }
    }
  }
 
});

if (!enableInfiniteSearchScroll()) {
    
    window.addEventListener('load', function(){
        $(window).bind('scroll', bindScroll)
    });
}

